import React, { FC, useContext, useEffect, useMemo, useState } from "react";
import facebookSvg from "images/Facebook.svg";
import twitterSvg from "images/Twitter.svg";
import googleSvg from "images/Google.svg";
import { Helmet } from "react-helmet";
import Input from "shared/Input/Input";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";

import { PhoneInput } from 'react-international-phone';
//import 'react-international-phone/style.css';
import { requestAPI } from "utils/api";
import { UIContext } from "contexts/UIContext";
import { GlobalDataContext } from "contexts/GlobalData";

export interface PageLoginProps {
  className?: string;
  modalSw?: boolean;
}



const SigninForm: FC<PageLoginProps> = ({ 
	className = "",
	modalSw = false
}) => {
	
	const {
		toast,
		modal,
	} = useContext(UIContext);  
	const { 
		initData
	} = useContext (GlobalDataContext);

	const navigate = useNavigate ();
	const location = useLocation();

	const [phone, setPhone] = useState('');
	const [countryCallingNumber, setCountryCallingNumber] = useState('');
	const [checkUser, setCheckUser] = useState ("GUEST");
	const [verificationCode, setVerificationCode] = useState('');

	useEffect(()=>{
		if (initData.token_info.permission_group === "user") navigate('/home');
	},[])

	if (initData.token_info.permission_group === "user") return (<></>);

	const changePhoneNumber = async (phone: string, meta: any) => {
		//console.log(meta)
		setCountryCallingNumber(meta.country.dialCode);
		setPhone(phone)
	};

	

	const modalClose = () => {
		
		if (modalSw) {
			modal({title: "CLOSE", contents: "", buttons: []});	
			navigate(0)
		} else {
			//const navigate = useNavigate();
			console.log('나오미 가즈아')
    		navigate(0)

		}
	}

	const handleContinue = async () => {

		const phoneNumber = phone.replace(`+${countryCallingNumber}`, '');
		
		const res_info: any = await requestAPI ('POST', `v1/auth`, {
			countryCallingNumber,
			phoneNumber
		});

		switch (res_info.code) {
			case 1000: 
				toast ({type: 'default', contents: '인증문자를 휴대폰으로 발송했어요'});
				setCheckUser("USER");

				break;
			case 1001:
				toast ({type: 'default', contents: '인증문자를 휴대폰으로 발송했어요'});
				setCheckUser("USER");
				break;
			case 4000: 
				toast ({
					type: 'warning', 
					contents: "휴대폰 번호 형식을 확인해 주세요"
				});
				break;
			case 4001: 
				setCheckUser("USER");
				break;
			case 4002: 
				toast ({
					type: 'warning', 
					contents: "지속적인 로그인 요청으로 차단하였으며 관리자에게 문의해 주세요"
				});
				break;
		}
	};
	
	const handleConfirm = async () => {

		const phoneNumber = phone.replace(`+${countryCallingNumber}`, '');

		// console.log(countryCallingNumber);
		// console.log(phoneNumber);
		// console.log(verificationCode);

		// /v1_auth_login-sms-check_post
		const res_info: any = await requestAPI ('POST', `v1/auth/signin`, {
			countryCallingNumber,
			phoneNumber,
			verificationCode
		});

		
		// console.log('체크 갖아ㅡ')
		// console.log(res_info);

		switch (res_info.code) {
			case 1000: /*로그인 성공*/ 
				modalClose ();
			break;
			case 4000: toast ({type: 'warning', contents: "휴대폰 번호 형식을 확인해 주세요"}); break;
			case 4001: toast ({type: 'warning', contents: "인증번호를 확인해 주세요"}); break;
			case 4999: toast ({type: 'warning', contents: "관리자에게 문의해 주세요. (에러코드 4999)"}); break;
		}
	};

	return (
		<>
			
			
				{checkUser === "GUEST"
				?
					<div className="grid grid-cols-1 gap-6">
						<label className="block">
							<span className="text-neutral-800 dark:text-neutral-200">
								전화번호
							</span>
							<PhoneInput
								style={
									{
										'--react-international-phone-country-selector-border-color-hover': "black",
										'--react-international-phone-background-color': (localStorage.theme==="dark")? 'rgba(var(--c-neutral-900), var(--tw-bg-opacity))':'white',
										'--react-international-phone-country-selector-background-color-hover': (localStorage.theme==="dark")? 'rgba(var(--c-neutral-900), var(--tw-bg-opacity))':'',
										'--react-international-phone-selected-dropdown-item-text-color': (localStorage.theme==="dark")? 'white':'',
										'--react-international-phone-dropdown-item-text-color': (localStorage.theme==="dark")? 'white':'',
										'--react-international-phone-selected-dropdown-item-background-color': (localStorage.theme==="dark")? 'rgba(var(--c-neutral-700), var(--tw-bg-opacity))':'',
									} as React.CSSProperties
								}
								inputClassName={
									"block w-full border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900 text-sm font-normal h-11 px-4 py-3 mt-1"
								}
								defaultCountry="kr"
								value={phone}
								onChange={(phone, meta) => changePhoneNumber(phone, meta)}
							/>
						</label>
						<ButtonPrimary
							onClick={() => handleContinue()}
						>
							로그인을 위한 문자 수신 요청
						</ButtonPrimary>
					</div>
				:
					(checkUser === "USER")
					?
						<div className="grid grid-cols-1 gap-6">
							<label className="block">
								<span className="text-neutral-800 dark:text-neutral-200">
									전화번호
								</span>
								<PhoneInput
									style={
										{
											'--react-international-phone-background-color': (localStorage.theme==="dark")? 'rgba(var(--c-neutral-900), var(--tw-bg-opacity))':'white',
											'--react-international-phone-country-selector-background-color-hover': (localStorage.theme==="dark")? 'rgba(var(--c-neutral-900), var(--tw-bg-opacity))':'',
											'--react-international-phone-selected-dropdown-item-text-color': (localStorage.theme==="dark")? 'white':'',
											'--react-international-phone-dropdown-item-text-color': (localStorage.theme==="dark")? 'white':'',
											'--react-international-phone-selected-dropdown-item-background-color': (localStorage.theme==="dark")? 'rgba(var(--c-neutral-700), var(--tw-bg-opacity))':'',
										} as React.CSSProperties
									}
									inputClassName={
										"block w-full border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900 text-sm font-normal h-11 px-4 py-3 mt-1"
									}
									defaultCountry="kr"
									value={phone}
									disabled={true}
								/>
							</label>
							<label className="block">
								<span className="text-neutral-800 dark:text-neutral-200">
									수신된 SMS 인증문자
								</span>
								<Input
									type="text"
									placeholder="0000"
									className="mt-1"
									value={verificationCode}
									onChange={(e) => setVerificationCode(e.currentTarget.value)}
								/>
							</label>
							<ButtonPrimary
								onClick={() => handleConfirm()}
							>
								확인
							</ButtonPrimary>
						</div>
					:
						<div className="grid grid-cols-1 gap-6">
							<label className="block">
								<span className="text-neutral-800 dark:text-neutral-200">
									수신된 SMS 인증문자
								</span>
								<Input
									type="text"
									placeholder="0000"
									className="mt-1"
									value={verificationCode}
									onChange={(e) => setVerificationCode(e.currentTarget.value)}
								/>
							</label>
							<ButtonPrimary
								onClick={() => handleConfirm()}
							>
								확인
							</ButtonPrimary>
						</div>
				}


		</>
  	);
};

export default SigninForm;
